/**
 * 修改属性值-只修改之前存在的值
 * @param {*} target 修改的目标
 * @param {*} value 修改的内容
 */
export function modifyData(target, value) {
  for (const key in value) {
    if (Object.prototype.hasOwnProperty.call(target, key)) {
      // target[key] = value[key];
      // 需要的话，深层逐个赋值
      if (target[key] && typeof target[key] === "object") {
        modifyData(target[key], value[key]);
      } else {
        target[key] = value[key];
      }
    }
  }
}

/**获取时分秒 */
export function formatDateTime(time) {
  let data = time ? new Date(time) : new Date();
  let hour = data.getHours();
  let minute = data.getMinutes();
  let second = data.getSeconds();
  return { hour, minute, second }
}